import { render } from "./DetailedList.vue?vue&type=template&id=7437192c&scoped=true"
import script from "./DetailedList.vue?vue&type=script&lang=js"
export * from "./DetailedList.vue?vue&type=script&lang=js"

import "./DetailedList.vue?vue&type=style&index=0&id=7437192c&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7437192c"]])

export default __exports__